import React, { useEffect, useRef, useState } from "react";
import cmsimage from "../../assests/cms-img.png";
import "./Aboutus.css";

type CounterProps = {
  target: number;
  suffix?: string;
};

const Counter: React.FC<CounterProps> = ({ target, suffix }) => {
  const [count, setCount] = useState(0);
  const [hasRun, setHasRun] = useState(false);
  const ref = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    let observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasRun) {
          setHasRun(true);

          let start = 0;
          const duration = 1000; // 2 sec
          const step = target / (duration / 16);

          const counter = setInterval(() => {
            start += step;
            if (start >= target) {
              clearInterval(counter);
              setCount(target);
            } else {
              setCount(Math.floor(start));
            }
          }, 16);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [target, hasRun]);

  return (
    <h3 ref={ref}>
      {count}
      {suffix}
    </h3>
  );
};

const Aboutus: React.FC = () => {
  return (
    <section id="about" className="why-section-container">
      <div className="why-section">
        <div className="about-container">
          <h3 className="about-us"> <span className="dot"></span>About us</h3>
          <h1 className="xyloite-overview">Empowering Growth Through Innovation</h1>
        </div>
      </div>

      <div className="why-container">
        <div className="why-image">
          <img src={cmsimage} alt="CMS & Development" />
        </div>

        <div className="why-content">
          <h2>Why Xyloite?</h2>
          <p>
            <span className="bold-span">XYLOITE TECHNOLOGIES</span> has been supporting clients across the globe since 2020.
            Started with 10 resources, we now operate with 50+ employees supporting clients
            on various technologies offshore & onsite. Our in-house R&D team continuously works
            to deliver innovation & automation on the projects we support for better business processes.
            We are a software engineering organization focused on building quality software products and services.
          </p>

          <div className="why-stats">
            <div className="stat-box blue">
              <Counter target={4} suffix="+" />
              <p className="why-para">Years Experience</p>
            </div>
            <div className="stat-box red">
              <Counter target={50} suffix="+" />
              <p className="why-para">Successful Projects</p>
            </div>
            <div className="stat-box green">
              <Counter target={10} suffix="+" />
              <p className="why-para">Global Presence</p>
            </div>
            <div className="stat-box yellow">
              <Counter target={98} suffix="%" />
              <p className="why-para">Repeat Customer Rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutus;
